import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient"; // ✅ Use centralized API client

const ENDPOINT = "/ictEnquiry/";

// ------------------ Thunks ------------------

// Fetch all enquiries
export const fetchIctEnquiries = createAsyncThunk(
  "ictEnquiry/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.get(ENDPOINT);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create a new enquiry
export const createIctEnquiry = createAsyncThunk(
  "ictEnquiry/create",
  async (newData, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post(ENDPOINT, newData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update an existing enquiry
export const updateIctEnquiry = createAsyncThunk(
  "ictEnquiry/update",
  async (updatedData, { rejectWithValue }) => {
    const { id, ...rest } = updatedData;
    try {
      const { data } = await apiClient.put(`${ENDPOINT}${id}/`, rest);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete an enquiry
export const deleteIctEnquiry = createAsyncThunk(
  "ictEnquiry/delete",
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`${ENDPOINT}${id}/`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ------------------ Slice ------------------

const ictEnquirySlice = createSlice({
  name: "ictEnquiry",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchIctEnquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIctEnquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchIctEnquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create
      .addCase(createIctEnquiry.fulfilled, (state, action) => {
        state.data.push(action.payload);
      })
      .addCase(createIctEnquiry.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update
      .addCase(updateIctEnquiry.fulfilled, (state, action) => {
        const updated = action.payload;
        const idx = state.data.findIndex((item) => item.id === updated.id);
        if (idx !== -1) {
          state.data[idx] = updated;
        }
      })
      .addCase(updateIctEnquiry.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteIctEnquiry.fulfilled, (state, action) => {
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteIctEnquiry.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ictEnquirySlice.reducer;
